<template>
  <b-overlay :show="loading" opacity="0.8">
    <b-modal
      id="add-or-update-modal"
      :visible="isAddActive"
      centered
      hide-footer
      hide-header
      no-close-on-esc
      no-close-on-backdrop
      size="md"
  
      @change="(val) => $emit('update:is-add-active', val)"
    >
      <template #default="{ hide }">
        <b-overlay :show="loading" class="px-2">
          <div class="d-flex justify-content-between align-items-center content-sidebar-header py-1" style="border-bottom: 1px solid #000000;">
            <h5 class="mb-0" style="font-weight: 400; font-size: 14px; line-height: 160%;">
              Lab Reports {{ uploads.length > 0 ? `(${uploads.length})` : '' }}
            </h5>

            <feather-icon class="ml-1 cursor-pointer" icon="XIcon" size="16" @click="hide" />
          </div>

          <b-row>
            <b-col cols="12" md="12">
              <b-form-group label-for="upload">
                <div v-if="uploads.length === 0" class="mt-2">No lab report uploads have been made.</div>
                <div v-else>
                  <div v-for="upload in uploads" :key="upload.id" class="mt-2">
                    <b-link v-if="upload.name" :href="upload.path" class="word-wrap">{{ upload.name }} - {{ formatSize(upload.size) }}</b-link>
                  </div>
                </div>
              </b-form-group>
            </b-col>
          </b-row>
        </b-overlay>
      </template>
    </b-modal>
  </b-overlay>
</template>
  
<script>
import {
  BCard,
  BImg,
  BRow,
  BCol,
  BBadge,
  BAlert,
  BButton,
  BAvatar,
  BFormGroup,
  BOverlay,
  BDropdown,
  BLink,
  BDropdownItem,
  BDropdownGroup
} from 'bootstrap-vue'

import { startCase } from 'lodash';

import Ripple from 'vue-ripple-directive'
import ListTable from "@/@core/components/ListTable/ListTable.vue";

  
export default {
  components: {
    BImg,
    BRow,
    BCol,
    BCard,
    BBadge,
    BAlert,
    BAvatar,
    BButton,
    BLink,
    BOverlay,
    BDropdown,
    BFormGroup,
    BDropdownItem,
    BDropdownGroup,

    ListTable,

  },
  directives: {
    Ripple,
  },
  props: {
    isAddActive: {
      type: Boolean,
      required: true,
    },
    uploads: {
      type: Array,
      required: false,
      default: null
    }
  },
  data() {
    return {
      loading: false,
      errorMessage: "",
      
    }
  },
  methods: {
    startCase
  }
}
</script>
  
<style scoped>
  .w-10 {
    width: 13% !important;
  }

  .word-wrap {
    white-space: normal;
    word-wrap: break-word;
  }
</style>
